<template>

  <v-row no-gutters :class="$vuetify.theme.dark?'grey-darken-3 pa-2 ':'white pa-2 '">

    <v-col cols="12" :lg="isHefe?12:6" class="px-1">
      <v-row no-gutters>
        <v-col cols="12">
          <v-list-item v-if="status!=='New'&&status!=='Invited'">
            <v-list-item-content>
              <v-list-item-subtitle class="subtitle">
                {{$language.jobDetails['Status']}}:
              </v-list-item-subtitle>
              <v-list-item-title class="headline font-weight-bold">
                {{$language.jobDetails.status[status]}}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="pt-2" v-if="isHefe&&status!=='Completed'">
              <v-speed-dial v-model="fab" direction="left" transition="slide-x-reverse-transition">
                <template v-slot:activator>
                  <v-btn v-model="fab" fab text small>
                    <v-icon v-if="fab" large color="primary">
                      mdi-close
                    </v-icon>
                    <v-icon v-else large color="primary">
                      settings
                    </v-icon>
                  </v-btn>
                </template>
                <v-btn small fab @click="$emit('edit')">
                  <v-icon color="amber darken-2">mdi-clipboard-edit-outline</v-icon>
                </v-btn>
                <v-btn small fab @click="$emit('end-contract')" v-if="isHefe&&status!=='Completed'&&status!=='Draft'">
                  <v-icon color="green darken-4">mdi-flag-checkered</v-icon>
                </v-btn>
                <v-btn small fab v-if="status==='Draft'" @click="$emit('delete')">
                  <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
                <v-btn small fab v-if="status!=='Draft'&&status!=='Completed'" @click="$emit('cancel')">
                  <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
              </v-speed-dial>
            </v-list-item-action>
            <v-list-item-action class="pt-2" v-else>
              <v-btn color="primary" class="px-4" @click="$emit('view-bid')" v-if="!isHefe&&!jobComplete&&status==='Applied'&&job.public.bid"><span class="white--text">{{ $language.jobDetails['View Bid'] }}</span></v-btn>
              <v-btn color="error" class="px-4" @click="$emit('withdraw')" v-if="!isHefe&&!jobComplete&&status==='Applied'&&!job.public.bid"><span class="white--text">{{ $language.jobDetails['Withdraw'] }}</span></v-btn>
              <v-btn color="error" class="px-4" @click="$emit('quit')" v-if="status==='Hired'"><span class="white--text">{{ $language.jobDetails['Quit'] }}</span></v-btn>
            </v-list-item-action>
          </v-list-item>
          <div v-if="!isHefe">
            <v-list-item dense @click="$router.replace('/stripe-registration')" v-if="!hasStripe||!payoutsEnabled" class="px-0">
              <v-list-item-avatar tile class="px-0">
                <v-icon color="error">info_outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row no-gutters justify="center">
                  <span class="caption error--text" v-if="hasStripe&&!payoutsEnabled">{{$language.jobDetails['Pending Stripe']}}</span>
                  <span class="caption error--text" v-if="!hasStripe&&!payoutsEnabled">{{$language.jobDetails['Stripe Required']}}</span>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-row v-if="(status ==='New' || status ==='Invited')&&hasStripe&&payoutsEnabled" justify="center">
              <v-col cols="12" align="center">
                <v-btn color="primary" large block @click="$emit('apply')" class="font-weight-bold" v-if="hasStripe&&payoutsEnabled">{{$language.jobDetails['Apply for this job!']}}</v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" class="my-1">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12">
          <v-list-item>
            <v-list-item-avatar tile size="48" v-if="(job.public || {}).category || false">
              <img :src="require(`@/assets/${job.public.category}.svg`)" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title :class="`headline`">
                {{job.public.title}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" class="my-1">
          <v-divider></v-divider>
        </v-col>
        <v-row no-gutters>
          <v-col cols="6">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle class="subtitle">
                  {{$language.jobDetails['Start Date']}}:
                </v-list-item-subtitle>
                <v-list-item-title :class="`${$vuetify.breakpoint.xs?'text-h8':'text-h6'} font-weight-bold`">
                  {{job.public.startDate|formatShortDate}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="6">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle class="subtitle">
                  {{$language.jobDetails['Contract End Date']}}:
                </v-list-item-subtitle>
                <v-list-item-title :class="`${$vuetify.breakpoint.xs?'text-h8':'text-h6'} font-weight-bold`">
                  {{job.public.contractEndDate|formatShortDate}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle class="subtitle">
                  {{$language.jobDetails['Start Time']}}:
                </v-list-item-subtitle>
                <v-list-item-title :class="`${$vuetify.breakpoint.xs?'text-h8':'text-h6'} font-weight-bold`">
                  {{(job.public.startTime||{}).h}}:{{(job.public.startTime||{}).mm}} {{(job.public.startTime||{}).A}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="6" class="pl-0">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle class="subtitle">
                  {{$language.jobDetails['Duration']}}:
                </v-list-item-subtitle>
                <v-list-item-title :class="`${$vuetify.breakpoint.xs?'text-h8':'text-h6'} font-weight-bold`">
                  {{job.public.hours}} {{job.public.hours|formatHour}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="6">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle class="subtitle">
                  {{$language.jobDetails['Rate']}}:
                </v-list-item-subtitle>
                <v-list-item-title :class="`${$vuetify.breakpoint.xs?'text-h8':'text-h6'} font-weight-bold`" v-if="job.public.bid">
                  {{$language.addJob['Bid']}}
                </v-list-item-title>
                <v-list-item-title :class="`${$vuetify.breakpoint.xs?'text-h8':'text-h6'} font-weight-bold`" v-else>
                  <span v-if="job.public.rateType ==='Hourly'">
                    ${{job.public.rate}} /hr
                  </span>
                  <span v-else>
                    ${{job.public.fixedCost}}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-col cols="12" v-if="job.public.repeat">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="subtitle">
                {{$language.jobDetails['Repeating Job']}}:
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-item-group v-if="(job.public.occ||{}).type===$language.addJob['Weeks']" v-model="job.public.dayToggle" multiple class="pt-2 px-4 pb-4 d-flex justify-space-around">
            <v-item v-slot:default="{ active, toggle }">
              <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">S</v-chip>
            </v-item>
            <v-item v-slot:default="{ active, toggle }">
              <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">M</v-chip>
            </v-item>
            <v-item v-slot:default="{ active, toggle }">
              <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">T</v-chip>
            </v-item>
            <v-item v-slot:default="{ active, toggle }">
              <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">W</v-chip>
            </v-item>
            <v-item v-slot:default="{ active, toggle }">
              <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">T</v-chip>
            </v-item>
            <v-item v-slot:default="{ active, toggle }">
              <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">F</v-chip>
            </v-item>
            <v-item v-slot:default="{ active, toggle }">
              <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">S</v-chip>
            </v-item>
          </v-item-group>
          <v-list-item>
            <v-list-item-content>
              <span class="subtitle">Repeats: {{job.public.scheduleText}}</span>
            </v-list-item-content>
          </v-list-item>
        </v-col>

        <v-col cols="12" class="my-1" v-if="!isHefe">
          <v-divider></v-divider>
        </v-col>

        <v-col cols="12" class=" py-4 d-flex justify-space-around" v-if="!isHefe">
          <v-btn fab size="48" outlined :href="job.public.address.url" :disabled="this.status==='Declined'||this.status==='New'">
            <v-icon>directions</v-icon>
          </v-btn>
          <a :href="`tel:${job.public.phone}`" style="text-decoration:none">
            <v-btn fab size="48" outlined :disabled="this.status==='Declined'||this.status==='New'">
              <v-icon>phone</v-icon>
            </v-btn>
          </a>
          <v-btn fab size="48" outlined @click="openChat" :disabled="this.status==='Declined'||this.status==='New'">
            <v-icon>chat</v-icon>
          </v-btn>
          <v-btn fab size="48" outlined @click="openTime" :disabled="this.status==='Declined'||this.status==='New'||this.status==='Invited'||this.status==='Applied'||jobComplete">
            <v-icon>mdi-play</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="12" class="my-1">
          <v-divider></v-divider>
        </v-col>

        <v-col cols="12" class="my-2">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="subtitle">
                {{$language.jobDetails['Job Description']}}:
              </v-list-item-subtitle>
              <span>{{job.public.jobDesc}}</span>
            </v-list-item-content>
            <v-list-item-action>
            </v-list-item-action>
          </v-list-item>
        </v-col>

        <v-col cols="12" class="my-1" v-if="!isHefe">
          <v-divider></v-divider>
        </v-col>

        <v-col cols="12" class="py-2" v-if="!isHefe">
          <v-list-item>
            <v-list-item-avatar size="48">
              <v-img :src="job.public.hefeAvatar">
              </v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title">
                {{job.public.hefeName}}
              </v-list-item-title>
              <v-list-item-subtitle class="subtitle">
                <v-row class="pl-2">
                  <v-rating v-model="job.public.hefeRating" small dense half-increments color="primary" background-color="primary" readonly></v-rating>
                  <span class=" caption ml-2">
                    ({{ job.public.hefeRating }})
                  </span>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
            </v-list-item-action>
          </v-list-item>
        </v-col>
        <v-col cols="12" class="my-1">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" v-if="isHefe">
          <v-carousel cycle height="240">
            <template v-for="(item,index) in job.public.pictures">
              <v-carousel-item :key="index">
                <v-sheet height="100%" tile>
                  <v-row class="fill-height" align="center" justify="center">
                    <v-img :src="item.url" cover height="300"></v-img>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </template>
            <v-carousel-item>
              <v-sheet height="100%" tile>
                <v-row class="fill-height" align="center" justify="center" pa-0>
                  <static-map :lat="(((job.public||{}).location||{})[0]||0)" :long="(((job.public||{}).location||{})[1]||0)" :size="[((this.$el||{}).clientWidth||380),240]"></static-map>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" :lg="isHefe?12:6" class="px-1" v-if="!isHefe">
      <v-row no-gutters>
        <v-col cols="11">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="subtitle">
                {{$language.jobDetails['Work Status']}}:
              </v-list-item-subtitle>
              <v-list-item-title class="headline font-weight-bold">
                <span class="font-weight-bold error--text" v-if="status==='Invited'||status==='New'">{{$language.jobDetails.shift['Not Applied']}}</span>
                <span class="font-weight-bold " v-if="status==='Applied'">{{$language.jobDetails.shift['Applied']}}</span>
                <span class="font-weight-bold error--text" v-if="!(applicant||{}).clockedIn&&!jobComplete&&!(applicant.clockLog||false)&&status!=='Invited'&&status!=='Applied'&&status!=='New'">{{$language.jobDetails.shift['Shift Not Started']}}</span>
                <span class="font-weight-bold " v-if="!(applicant||{}).clockedIn&&jobComplete">{{$language.jobDetails.shift['Completed']}}</span>
                <span class="font-weight-bold success--text" v-if="(applicant||{}).clockedIn">{{$language.jobDetails.shift['Clocked In']}}</span>
                <span class="font-weight-bold error--text" v-if="!(applicant||{}).clockedIn&&(applicant.clockLog||false)">{{$language.jobDetails.shift['Clocked Out']}}</span>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              {{((job.applicants||{})[currentUser.uid]||{}).clockedIn}}
            </v-list-item-action>
          </v-list-item>
        </v-col>

        <v-col cols="12" class="my-1">
          <v-divider></v-divider>
        </v-col>

        <v-col cols="12">

          <v-carousel cycle height="240">
            <template v-for="(item,index) in job.public.pictures">
              <v-carousel-item :key="index">
                <v-sheet height="100%" tile>
                  <v-row class="fill-height" align="center" justify="center">
                    <v-img :src="item.url" cover height="300"></v-img>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </template>
            <a :href="job.public.address.url" v-if="this.status!=='New'&&this.status!=='Applied'&&this.status!=='Declined'">
              <v-carousel-item>
                <v-sheet height="100%" tile>
                  <v-row class="fill-height" align="center" justify="center" pa-0>
                    <static-map :lat="(((job.public||{}).location||{})[0]||0)" :long="(((job.public||{}).location||{})[1]||0)" :size="[((this.$el||{}).clientWidth||200),240]"></static-map>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </a>
          </v-carousel>

        </v-col>
      </v-row>
    </v-col>

    <v-snackbar v-model="snackbar.show" :color="snackbar.status" :timeout="1500">
      {{ snackbar.message }}
    </v-snackbar>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// import LogContainer from '@/components/common/log/LogContainer'
// import ApplicantsContainer from '@/components/jefe/applicants/ApplicantsContainer'
import StaticMap from '@/components/common/StaticMap'

export default {
  props: [
    'editJob',
    'summaryView',
    'status',
    'hasStarted',
    'publicView',
    'applicant',
    'applicants',
    'payouts',
    'isHefe'

  ],
  components: {
    // LogContainer
    // ApplicantsContainer,
    StaticMap
  },
  data () {
    return {
      fab: false,
      show: false,
      showCroppa: false,
      noLocation: false,
      noImage: false,
      loading: false,
      invite: false,
      invitedWorkers: [],
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      },
      paymentExplanation: false,
      validForm: false,
      validation: {
        title: true,
        description: true,
        rateType: true,
        workers: true,
        fixedCost: true,
        rate: true,
        hours: true
      },
      initial: true,
      uploading: false,
      uploadEnd: false,
      progressUpload: 0,
      fileName: '',
      uploadTask: '',
      dialog: '',
      job: {
        public: {
          picture: null,
          public: true,
          status: 'Draft',
          category: '',
          title: '',
          jobDesc: '',
          rateType: null,
          days: null,
          workers: null,
          hours: null,
          fixedCost: null,
          location: [],
          startDate: new Date().toISOString().slice(0, 10),
          address: {
            url: null
          },
          repeat: this.$language.addJob['Does not repeat']
        },
        mlmReferral: []
      },
      address: '',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      modal2: false,
      requiredRule: [(v) => (v && v.length < 100) || 'Required field'],
      descRules: [
        (v) =>
          (v && (v || '').length <= 1000) || this.$language.validations['Description should be less than 1000 characters']
      ],
      numberRules: [
        (v) =>
          /[0-9]|\./.test(v) ||
          this.$language.validations['Only numbers allowed'],
        (v) =>
          (v && v > 0 && v <= 1000000) ||
          this.$language.validations['Invalid value']
      ],
      nowDate: new Date().toISOString().slice(0, 10),
      croppaDialog: false,
      index: 0,
      filePreview: {
        img: '',
        aspect: 1,
        x: 0,
        y: 0
      },
      showPreview: false,
      myCroppa: {},
      showMap: false,
      mapIndex: 1,
      imgIndex: 2,
      customRepeatDialog: false
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'categories']),
    timeFromNow () {
      return moment(`${this.job.public.startDate}T${(this.job.public.startTime || {}).h}.${(this.job.public.startTime || {}).mm}${(this.job.public.startTime || {}).A}`, ['YYYY-MM-DD HH.mm a'])
        .fromNow()
    },
    formattedName () {
      var str = (((this.job || {}).public || {}).hefeName || 'N N').split(' ')
      var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      return name
    },
    hasStripe () {
      var pending = (((this.userProfile || {}).stripeAccount || {}).account || false)
      return pending
    },
    payoutsEnabled () {
      var pending = ((((this.userProfile || {}).stripeAccount || {}).account || {}).payouts_enabled || false)
      return pending
    },
    jobComplete () {
      return (!((this.job || {}).public || {}).repeat && (this.status === 'Paid' || this.status === 'Pending Payment' || this.status === 'Completed')) || this.status === 'Completed'
    }
  },
  methods: {
    openExpander (item) {
      this.show = this.show === item._key ? false : item.key
    },
    computedDateFormattedMomentjs () {
      return this.date ? moment(this.date).format('dddd, MMMM Do YYYY') : ''
    },
    openChat () {
      this.$store.commit('setChatOpen', { open: true, date: new Date() })
      this.$nextTick(() => {
        this.$store.dispatch('changeChatSelection', { jobId: this.job.public._key, isHefe: this.isHefe, currentUser: this.currentUser.uid })
      })
    },
    openTime () {
      this.$store.commit('setTimeOpen', { open: true, date: new Date() })
      this.$nextTick(() => {
        this.$store.dispatch('changeTimeSelection', { jobId: this.job.public._key })
      })
    }
  },
  watch: {
    editJob () {
      this.job.public = this.editJob
      this.$nextTick(() => {
        if (this.$refs.search) {
          this.$refs.search.$el.value = this.job.public.address.formatted_address
        }
      })

      if (this.$refs.myCroppa) {
        this.$refs.myCroppa.refresh()
      }
    },

    'myCroppa.img': function (val) {
      this.showPreview = this.myCroppa.img === null ? 0 : 1
      this.index += this.index
      this.imgIndex += this.imgIndex
      this.job.public.picture = null
    },
    'job.public.repeat': function (val) {
      if (val === 'Custom...' || val === 'Personalizado...') {
        this.customRepeatDialog = true
      }
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.showCroppa = true
    })
  },
  filters: {

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(moment(`${this.job.startDate}T${val.h} ${val.mm} ${val.A}`, ['HH.mm a']).format('hh:mm a'))
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    formatHour (val) {
      if (!val) {
        return '-'
      }
      return val === parseInt(1) ? 'hour' : 'hours'
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    }
  }
}
</script>

<style scoped>
.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 2px solid #bdbdbd !important;
  border-radius: 5px;
  padding-left: 10px !important;
}

.theme--light.v-text-field--outline > .v-input__control > .v-input__slot:hover {
  border: 2px solid #bdbdbd !important;
}

/*.croppa-container {
  width: calc(100vw - 40px);
  max-width: 840px !important;
  height: 200px;
  margin: 0 auto;
  display: block;
}*/

.no-padding-hint > .v-input__control > .v-text-field__details {
  padding: 0px !important;
}

.scrollable {
  overflow-y: auto;
}
.v-btn--outlined {
  border-width: 3px;
}
</style>
